import ReactDOM from 'react-dom';
import 'core-js/shim';
import smoothscroll from 'smoothscroll-polyfill';
import analytics from './site-render/src/lib/analytics';
import registerServiceWorker from './registerServiceWorker';
import createStore from './redux/createStore';
import renderAppWithProviders from './renderAppWithProviders';
import renderRegisterWithProviders from './register/renderRegisterWithProviders';
import graphQLClient from './graphqlClient';

const eventId = window.__EVENT_ID__ || process.env.REACT_APP_EVENT_ID;
const isRegister = window.__IS_REGISTER__ || process.env.REACT_APP_IS_REGISTER;

const client = graphQLClient(isRegister, eventId);
const store = createStore(client, window.__INITIAL_STATE__);

analytics.init(client);
smoothscroll.polyfill();

if (isRegister) {
  ReactDOM.hydrate(
    renderRegisterWithProviders(store, client, eventId),
    document.getElementById('root'),
  );
} else {
  ReactDOM.hydrate(renderAppWithProviders(store, client, eventId), document.getElementById('root'));
}

if (window.__BY_DOMAIN__ && window.location.protocol === 'https:') {
  registerServiceWorker();
}



// WEBPACK FOOTER //
// ./src/index.js